import axios from "axios";
import { getToken } from "./msalConfig";

// Attaches the signed-in user's MSAL token to every request made through
// the returned instance, so every service shares this one auth interceptor.
export const createApiClient = (baseURL) => {
  const client = axios.create({ baseURL });

  client.interceptors.request.use(
    async (config) => {
      const token = await getToken();

      config.headers = config.headers || {};
      config.headers["oidc-token"] = token;

      return config;
    },
    (error) => Promise.reject(error)
  );

  return client;
};

const apiClient = createApiClient(process.env.REACT_APP_BACKEND_URI);

export const apiService = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  patch: (url, data, config) => apiClient.patch(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
};

export default apiClient;
